import { PersonIdTyp } from "@/utils/constants";
import moment from "moment";

export const getAge = ({ dateOfBirth }: { dateOfBirth?: string }) => {
    if (!dateOfBirth) {
        return 0;
    }

    const birth = moment(dateOfBirth);
    const now = moment(Date.now());

    return now.diff(birth, "years");
};

export const hasPersonnummer = ({ personIdType }: { personIdType: typeof PersonIdTyp[keyof typeof PersonIdTyp] }) => {
    return personIdType === PersonIdTyp.PERSONNUMMER;
};
